import { KintellGroup, User } from '@/models'
import { join, single, paginated } from '@/store/build'
import { isEmpty } from 'lodash-es'
import { make } from 'vuex-pathify'

const activeKintellGroup = single('activeKintellGroup', KintellGroup)

const activeKintellGroupMember = single('activeKintellGroupMember', User)

const activeKintellGroupMembers = paginated('activeKintellGroupMembers', User, async ({ state }) => {
  const params = state.kintellGroup.activeKintellGroupMembersSearchParams

  const query = (new KintellGroup({ id: params.id }))
    .members()
    .params(params)
    .orderBy(params.sortBy ? params.sortBy : 'kg_role')

  if (params.query) {
    query.where('search-name', params.query)
  }

  if (params.role) {
    query.where('group-role', params.role)
  }

  return await query
    .pagination({
      page: state.kintellGroup.activeKintellGroupMembersPagination.current_page,
      limit: state.kintellGroup.activeKintellGroupMembersPagination.per_page
    })
    .get()
}, {
  appendResults: false,
  modifyQueryParams: false,
  cacheMinutes: 0
})

function generateApplyStore () {
  function state () {
    return {
      applyState: 'IDLE',
      // To be used when user drop off from the application process
      applyReportName: '',
    }
  }

  return {
    state: state(),
    mutations: make.mutations(state),
  }
}

let {
  // eslint-disable-next-line prefer-const
  state,
  // eslint-disable-next-line prefer-const
  getters,
  // eslint-disable-next-line prefer-const
  mutations,
  actions
} = join(
  activeKintellGroup,
  activeKintellGroupMembers,
  activeKintellGroupMember,
  generateApplyStore(),
)
// extend actions
actions = {
  ...actions,
  async loadKintellGroupForSlug ({ commit, state, rootState }, { kintellGroup, error, useCache = true }) {
    // already loaded
    if (
      useCache &&
      // check kintell card exists and slug matches
      state.activeKintellGroup && (state.activeKintellGroup?.slug === kintellGroup)) {
      return true
    }

    const kintellGroupModel = await KintellGroup.where('slug', kintellGroup).first()
    commit('SET_ACTIVE_KINTELL_GROUP', kintellGroupModel)
    return true
  },

  async loadKintellGroupMemberForSlug ({ commit, state, rootState }, { kintellGroup, member, error }) {
    const kintellGroupModel = await KintellGroup.where('slug', kintellGroup).first()
    if (isEmpty(kintellGroupModel)) {
      error({ statusCode: 404, message: 'Sorry, the group cannot be found.' })
      return false
    }
    // Get Group member of the group
    const kintellGroupMember = await new KintellGroup({ id: kintellGroupModel.id })
      .members()
      .where('userId', member)
      .first()
    if (isEmpty(kintellGroupMember)) {
      error({ statusCode: 404, message: 'Sorry, the page not found.' })
      return false
    }
    commit('SET_ACTIVE_KINTELL_GROUP', kintellGroupModel)
    commit('SET_ACTIVE_KINTELL_GROUP_MEMBER', kintellGroupMember)
    return true
  },

  async refreshMember ({ commit, state, rootState }, userId = null) {
    const activeGroupMemberId = userId ?? state.activeKintellGroupMember.id
    const kintellGroupMember = await new KintellGroup({ id: state.activeKintellGroup.id })
      .members()
      .where('userId', activeGroupMemberId)
      .first()
    commit('SET_ACTIVE_KINTELL_GROUP_MEMBER', kintellGroupMember)
    return true
  }
}

// export store
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
